import { useState } from 'react'
import { Range, getTrackBackground } from "react-range";
import { t } from '../../../utilities/translator';
import { getDisplayPrice } from '../../../utilities/priceHelper';

const RangeSlider = ({
  initial,
  selected,
  onChange,
  sliderColors = ["#ffffff", "#212121", "#ffffff"],
}) => {
  const [values, setValues] = useState(selected);
  const isRtl = document.querySelector("html").getAttribute("dir") === "rtl";

  const handleChange = (values) => {
    setValues(values)
  }

  const onFinalChange = (values) => {
    onChange(values);
    setValues(values);
  }

  return (
    <div>
      <Range
        step={5}
        rtl={isRtl}
        min={initial.min}
        max={initial.max}
        values={values}
        onChange={handleChange}
        onFinalChange={onFinalChange}
        renderTrack={({ props, children }) => (
          <div className="track-wrap new-track-wrap">
            <div
              {...props}
              className="track-line mt-3"
              style={{
                ...props.style,
                background: getTrackBackground({
                  values,
                  colors: sliderColors,
                  min: initial.min,
                  max: initial.max,
                  rtl: isRtl,
                })
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '26px',
              width: '26px',
              borderRadius: '26px',
              backgroundColor: '#212121'
            }}
          />
        )}
      />

      <div className="range-slider-values mt-4">
        <div className="range-slider__min gap-1">
          <div className="range-slider__label body-small leading-none">
            {t("mainFilter.min")}
          </div>
          <div className="range-slider__value label-large leading-none !font-semibold">{getDisplayPrice(values[0])}</div>
        </div>
        <div className="range-slider__max gap-1">
          <div className="range-slider__label body-small leading-none">
            {t("mainFilter.max")}
          </div>
          <div className="range-slider__value label-large leading-none !font-semibold">{getDisplayPrice(values[1])}</div>
        </div>
      </div>
    </div>
  )
}

export default RangeSlider
